export function sum<T>(array: T[], callback: (item: T) => number): number
{
    let result = 0;
    for (let item of array)
    {
        result += callback(item);
    }

    return result;
}